export const environment = {
  production: false,
  ARCGIS_FEATURE_SERVER:
    'https://services-eu1.arcgis.com/AcdYbPzrkOfBOQDL/arcgis/rest/services/avbrudd2visning/FeatureServer',
  GEODATA_ONLINE_SEARCH_API:
    'Jif5gEV8yzDpkv_L0tAIzydmchlxNJsuOxCzkuRLY4prtXH5EjL7vHG8ZDfY5tt1MR-c6X6pk_JgJW8nRxdxAQ4aB9i23q8ifd-NG-Pmejc.',
};
